module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_48.a9982178.mp3";